"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortByKey = void 0;
const sortByKey = (key) => (a, b) => a[key] - b[key];
exports.sortByKey = sortByKey;
